import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import projects from 'scoreboard/projects/projects'
import ReportConstants from 'scoreboard/reports/report-constants'
const { HEADER_TYPE_BREAKDOWN_ROW, HEADER_TYPE_FIELD_ROW } = ReportConstants
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'
import globals from 'scoreboard/components/globals'
const DEFAULT_GROUPING_ID = _.uniqueId('group')

const MetricComparisonModel = ScorecardReportModel.extend({
	defaults: function() {
		return _.extend(ScorecardReportModel.prototype.defaults(), {
			label: i18n.get('report.metricComparisonReport.title'),
			filters: {
				compareScorecardItems: [{
					orgLabels: {},
					itemLabels:{},
					includeDescendants: {},
					deducedOrgIds:[]
				}],
				types: [{
					values: ['metric']
				}],
				projectIds: [{values:[projects.id]}]
			},
			structure: {
				stacks: [{
						columns: [this._defaultColumnData('organization', {groupingId: DEFAULT_GROUPING_ID, sortType:'tree', groupingSortType: 'tree'})]
					}, {
						columns: [
							this._defaultColumnData('actual', {
								abbreviated: true,
								customLabel: true,
								colorType: 'scoring',
								label: 'report.customReport.metricValue'
							})
						],
						repeatBy: {
							headerOrder: [HEADER_TYPE_BREAKDOWN_ROW,
								HEADER_TYPE_BREAKDOWN_ROW,
								HEADER_TYPE_FIELD_ROW],
							breakdowns: [
								{ range: { calendarId: null, first:0, last: 0, relative: true}, hideLabel: true },
								{ breakdownBy: 'label'}
							]
						}
					}
				]
			},
			groupBy: [DEFAULT_GROUPING_ID],
			showIndividualRecords: false,
			showAbbreviatedValues: true
		})
	}
})

function resolveOrgs(model) {
	let url = `api/reports/org-max-metrics?currentOrgId=${globals.orgId}`
	return $.post(url, JSON.stringify(model.get('deducedOrgIds')))
		.always(data => {
			model.unset('orgAndScorecardRoot', {silent: !_.isNil(data)})
			model.set('orgAndScorecardRoot', data || {})
		})
}

_.extend(MetricComparisonModel, {
	resolveOrgs
})
export default MetricComparisonModel
export { resolveOrgs }

MetricComparisonModel.__filename__ = 'reports/wizard/metric-comparison/metric-comparison-model.js'
